function convert(unitFrom, unitTo, valueFrom) {
  let units = [
    {
      name: 'Celsius',
      val: 0,
    },
    {
      name: 'Fahrenheit',
      val: 0,
    },
    {
      name: 'Kelvin',
      val: 0,
    },
  ]
  valueFrom = parseFloat(valueFrom)
  const index = units.findIndex((temp) => temp.name === unitTo)
  let C = valueFrom ? valueFrom : 0
  if (unitFrom === 'Fahrenheit') {
    C = ((valueFrom - 32) * 5) / 9
  } else if (unitFrom === 'Kelvin') {
    C = valueFrom - 273.15
  }
  const F = (C / 5) * 9 + 32
  const K = C + 273.15
  units[0].val = C.toString()
  units[1].val = F.toString()
  units[2].val = K.toString()
  return units[index].val
}

export default convert



// WEBPACK FOOTER //
// ./src/utils/temperature.js